import { render } from "./CrudOnlineOnly.vue?vue&type=template&id=5da8e1a1"
import script from "./CrudOnlineOnly.vue?vue&type=script&lang=js"
export * from "./CrudOnlineOnly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__